module.exports = __webpack_public_path__ + "static/media/Soccer-banner.64f13615.jpg";